export default __webpack_public_path__ + "static/media/benefit_3@2x.c191afd6.png";